/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserDetailAppMetadata } from './UserDetailAppMetadata';
import {
    UserDetailAppMetadataFromJSON,
    UserDetailAppMetadataFromJSONTyped,
    UserDetailAppMetadataToJSON,
} from './UserDetailAppMetadata';
import type { UserDetailUserType } from './UserDetailUserType';
import {
    UserDetailUserTypeFromJSON,
    UserDetailUserTypeFromJSONTyped,
    UserDetailUserTypeToJSON,
} from './UserDetailUserType';
import type { UserFacilityAccess } from './UserFacilityAccess';
import {
    UserFacilityAccessFromJSON,
    UserFacilityAccessFromJSONTyped,
    UserFacilityAccessToJSON,
} from './UserFacilityAccess';

/**
 * 
 * @export
 * @interface UserDetail
 */
export interface UserDetail {
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    status: UserDetailStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    auth_method: UserDetailAuthMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    gender?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    dob?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    date_of_hire?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    s3_photo_key?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    s3_photo_url?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    pin?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    last_sign_in_time?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    emergency_contact_name?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    emergency_contact_number?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserDetail
     */
    receive_crm_notifications?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    facility_id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    user_type_id: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    state_id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    organization_employment_type_id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    login_url_preference?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    hospital_chat_signature?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserDetail
     */
    is_deleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    deletedAt?: string;
    /**
     * 
     * @type {UserDetailUserType}
     * @memberof UserDetail
     */
    user_type?: UserDetailUserType;
    /**
     * 
     * @type {Array<UserFacilityAccess>}
     * @memberof UserDetail
     */
    user_facility_accesses?: Array<UserFacilityAccess>;
    /**
     * 
     * @type {UserDetailAppMetadata}
     * @memberof UserDetail
     */
    app_metadata?: UserDetailAppMetadata;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserDetail
     */
    enabled_dynamic_permissions?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    email_hash?: string;
}


/**
 * @export
 */
export const UserDetailStatusEnum = {
    Active: 'active',
    Pending: 'pending',
    Deactivated: 'deactivated'
} as const;
export type UserDetailStatusEnum = typeof UserDetailStatusEnum[keyof typeof UserDetailStatusEnum];

/**
 * @export
 */
export const UserDetailAuthMethodEnum = {
    Password: 'password',
    Sso: 'sso'
} as const;
export type UserDetailAuthMethodEnum = typeof UserDetailAuthMethodEnum[keyof typeof UserDetailAuthMethodEnum];


/**
 * Check if a given object implements the UserDetail interface.
 */
export function instanceOfUserDetail(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "first_name" in value;
    isInstance = isInstance && "last_name" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "auth_method" in value;
    isInstance = isInstance && "user_type_id" in value;

    return isInstance;
}

export function UserDetailFromJSON(json: any): UserDetail {
    return UserDetailFromJSONTyped(json, false);
}

export function UserDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'status': json['status'],
        'auth_method': json['auth_method'],
        'username': !exists(json, 'username') ? undefined : json['username'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'gender': !exists(json, 'gender') ? undefined : json['gender'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'dob': !exists(json, 'dob') ? undefined : json['dob'],
        'ssn': !exists(json, 'ssn') ? undefined : json['ssn'],
        'date_of_hire': !exists(json, 'date_of_hire') ? undefined : json['date_of_hire'],
        's3_photo_key': !exists(json, 's3_photo_key') ? undefined : json['s3_photo_key'],
        's3_photo_url': !exists(json, 's3_photo_url') ? undefined : json['s3_photo_url'],
        'pin': !exists(json, 'pin') ? undefined : json['pin'],
        'last_sign_in_time': !exists(json, 'last_sign_in_time') ? undefined : json['last_sign_in_time'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'emergency_contact_name': !exists(json, 'emergency_contact_name') ? undefined : json['emergency_contact_name'],
        'emergency_contact_number': !exists(json, 'emergency_contact_number') ? undefined : json['emergency_contact_number'],
        'receive_crm_notifications': !exists(json, 'receive_crm_notifications') ? undefined : json['receive_crm_notifications'],
        'facility_id': !exists(json, 'facility_id') ? undefined : json['facility_id'],
        'user_type_id': json['user_type_id'],
        'state_id': !exists(json, 'state_id') ? undefined : json['state_id'],
        'organization_employment_type_id': !exists(json, 'organization_employment_type_id') ? undefined : json['organization_employment_type_id'],
        'login_url_preference': !exists(json, 'login_url_preference') ? undefined : json['login_url_preference'],
        'hospital_chat_signature': !exists(json, 'hospital_chat_signature') ? undefined : json['hospital_chat_signature'],
        'is_deleted': !exists(json, 'is_deleted') ? undefined : json['is_deleted'],
        'deletedAt': !exists(json, 'deletedAt') ? undefined : json['deletedAt'],
        'user_type': !exists(json, 'user_type') ? undefined : UserDetailUserTypeFromJSON(json['user_type']),
        'user_facility_accesses': !exists(json, 'user_facility_accesses') ? undefined : ((json['user_facility_accesses'] as Array<any>).map(UserFacilityAccessFromJSON)),
        'app_metadata': !exists(json, 'app_metadata') ? undefined : UserDetailAppMetadataFromJSON(json['app_metadata']),
        'enabled_dynamic_permissions': !exists(json, 'enabled_dynamic_permissions') ? undefined : json['enabled_dynamic_permissions'],
        'email_hash': !exists(json, 'email_hash') ? undefined : json['email_hash'],
    };
}

export function UserDetailToJSON(value?: UserDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'email': value.email,
        'status': value.status,
        'auth_method': value.auth_method,
        'username': value.username,
        'title': value.title,
        'gender': value.gender,
        'phone': value.phone,
        'dob': value.dob,
        'ssn': value.ssn,
        'date_of_hire': value.date_of_hire,
        's3_photo_key': value.s3_photo_key,
        's3_photo_url': value.s3_photo_url,
        'pin': value.pin,
        'last_sign_in_time': value.last_sign_in_time,
        'address': value.address,
        'emergency_contact_name': value.emergency_contact_name,
        'emergency_contact_number': value.emergency_contact_number,
        'receive_crm_notifications': value.receive_crm_notifications,
        'facility_id': value.facility_id,
        'user_type_id': value.user_type_id,
        'state_id': value.state_id,
        'organization_employment_type_id': value.organization_employment_type_id,
        'login_url_preference': value.login_url_preference,
        'hospital_chat_signature': value.hospital_chat_signature,
        'is_deleted': value.is_deleted,
        'deletedAt': value.deletedAt,
        'user_type': UserDetailUserTypeToJSON(value.user_type),
        'user_facility_accesses': value.user_facility_accesses === undefined ? undefined : ((value.user_facility_accesses as Array<any>).map(UserFacilityAccessToJSON)),
        'app_metadata': UserDetailAppMetadataToJSON(value.app_metadata),
        'enabled_dynamic_permissions': value.enabled_dynamic_permissions,
        'email_hash': value.email_hash,
    };
}

